// AUTO-GENERATED by scripts/gen-icon-shim.mjs - Do not edit manually
// Custom icons NOT in Lucide — import via: import { Name } from "@/icons"
import * as React from "react";
import LinkedinLogoIconSvg from "../app/_assets/icons/linkedin-logo.svg";
export const LinkedinLogoIcon = (props) => React.createElement(LinkedinLogoIconSvg, props);